import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { SubtypeExamService } from '../../../core/services/subtype-exam/subtype-exam/subtype-exam.service'
import { MatOption } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import {ExamTypeService} from '../../../core/services/exam-type/document-type/exam-type.service';

@Component({
  selector: 'subtype-exam-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelectModule,
  ],
  templateUrl: './subtype-exam-edit.component.html',
  styleUrl: './subtype-exam-edit.component.scss',
  providers: [SubtypeExamService],
  standalone: true,
})
export class SubtypeExamEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceSpecificationService: SubtypeExamService,
    private examTypeService: ExamTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<SubtypeExamEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
    this.listTypeService()
  }

  listTypeService() {
    this.examTypeService.listExamType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceSpecificationService.editServiceSpecification(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.itemEdit.subtipo_id,
      descricao: this.form.controls['description'].value,
      nome: this.form.controls['name'].value,
      tipo_exame_id: this.form.controls['typeExam'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.subtipo_id, [Validators.required]],
      description: [this.itemEdit.subtipo_descricao, [Validators.required]],
      typeExam: [this.itemEdit.tipo_id, [Validators.required]],
      name: [this.itemEdit.subtipo_nome, [Validators.required]],
    })
    this.form.get('code')?.disable()
  }
}
